import React, { useState, useRef, useEffect } from 'react';
import moment from 'moment';
import GoogleMapReact from 'google-map-react';
import useSupercluster from 'use-supercluster';
import Slider from 'react-slick';
import desktopIcon from '../../Images/desktop_blue.png';
import mapPlaceholder from '../../Images/map_no_data.png';
import styles from './InvestigationMap.module.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import useFeature from '../../../SystemSettings/hooks/featureFlags/useFeature';
import { FEATURE_FLAGS_NAMES } from '@silverfort-nodelibs/common/utils/consts';
import { isFeatureActive } from '@silverfort-nodelibs/common/utils/common';
const MAP_STYLE = [
    {
        featureType: 'administrative',
        elementType: 'all',
        stylers: [
            {
                visibility: 'on'
            },
            {
                lightness: 33
            }
        ]
    },
    {
        featureType: 'administrative',
        elementType: 'labels',
        stylers: [
            {
                saturation: '-100'
            }
        ]
    },
    {
        featureType: 'administrative',
        elementType: 'labels.text',
        stylers: [
            {
                gamma: '0.75'
            }
        ]
    },
    {
        featureType: 'administrative.neighborhood',
        elementType: 'labels.text.fill',
        stylers: [
            {
                lightness: '-37'
            }
        ]
    },
    {
        featureType: 'landscape',
        elementType: 'geometry',
        stylers: [
            {
                color: '#f9f9f9'
            }
        ]
    },
    {
        featureType: 'landscape.man_made',
        elementType: 'geometry',
        stylers: [
            {
                saturation: '-100'
            },
            {
                lightness: '40'
            },
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'landscape.natural',
        elementType: 'labels.text.fill',
        stylers: [
            {
                saturation: '-100'
            },
            {
                lightness: '-37'
            }
        ]
    },
    {
        featureType: 'landscape.natural',
        elementType: 'labels.text.stroke',
        stylers: [
            {
                saturation: '-100'
            },
            {
                lightness: '100'
            },
            {
                weight: '2'
            }
        ]
    },
    {
        featureType: 'landscape.natural',
        elementType: 'labels.icon',
        stylers: [
            {
                saturation: '-100'
            }
        ]
    },
    {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [
            {
                saturation: '-100'
            },
            {
                lightness: '80'
            }
        ]
    },
    {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [
            {
                saturation: '-100'
            },
            {
                lightness: '0'
            }
        ]
    },
    {
        featureType: 'poi.attraction',
        elementType: 'geometry',
        stylers: [
            {
                lightness: '-4'
            },
            {
                saturation: '-100'
            }
        ]
    },
    {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [
            {
                color: '#c5dac6'
            },
            {
                visibility: 'on'
            },
            {
                saturation: '-95'
            },
            {
                lightness: '62'
            }
        ]
    },
    {
        featureType: 'poi.park',
        elementType: 'labels',
        stylers: [
            {
                visibility: 'on'
            },
            {
                lightness: 20
            }
        ]
    },
    {
        featureType: 'road',
        elementType: 'all',
        stylers: [
            {
                lightness: 20
            }
        ]
    },
    {
        featureType: 'road',
        elementType: 'labels',
        stylers: [
            {
                saturation: '-100'
            },
            {
                gamma: '1.00'
            }
        ]
    },
    {
        featureType: 'road',
        elementType: 'labels.text',
        stylers: [
            {
                gamma: '0.50'
            }
        ]
    },
    {
        featureType: 'road',
        elementType: 'labels.icon',
        stylers: [
            {
                saturation: '-100'
            },
            {
                gamma: '0.50'
            }
        ]
    },
    {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [
            {
                color: '#c5c6c6'
            },
            {
                saturation: '-100'
            }
        ]
    },
    {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [
            {
                lightness: '-13'
            }
        ]
    },
    {
        featureType: 'road.highway',
        elementType: 'labels.icon',
        stylers: [
            {
                lightness: '0'
            },
            {
                gamma: '1.09'
            }
        ]
    },
    {
        featureType: 'road.arterial',
        elementType: 'geometry',
        stylers: [
            {
                color: '#e4d7c6'
            },
            {
                saturation: '-100'
            },
            {
                lightness: '47'
            }
        ]
    },
    {
        featureType: 'road.arterial',
        elementType: 'geometry.stroke',
        stylers: [
            {
                lightness: '-12'
            }
        ]
    },
    {
        featureType: 'road.arterial',
        elementType: 'labels.icon',
        stylers: [
            {
                saturation: '-100'
            }
        ]
    },
    {
        featureType: 'road.local',
        elementType: 'geometry',
        stylers: [
            {
                color: '#fbfaf7'
            },
            {
                lightness: '77'
            }
        ]
    },
    {
        featureType: 'road.local',
        elementType: 'geometry.fill',
        stylers: [
            {
                lightness: '-5'
            },
            {
                saturation: '-100'
            }
        ]
    },
    {
        featureType: 'road.local',
        elementType: 'geometry.stroke',
        stylers: [
            {
                saturation: '-100'
            },
            {
                lightness: '-15'
            }
        ]
    },
    {
        featureType: 'transit.station.airport',
        elementType: 'geometry',
        stylers: [
            {
                lightness: '47'
            },
            {
                saturation: '-100'
            }
        ]
    },
    {
        featureType: 'water',
        elementType: 'all',
        stylers: [
            {
                visibility: 'on'
            },
            {
                color: '#acbcc9'
            }
        ]
    },
    {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [
            {
                saturation: '53'
            }
        ]
    },
    {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [
            {
                lightness: '-42'
            },
            {
                saturation: '17'
            }
        ]
    },
    {
        featureType: 'water',
        elementType: 'labels.text.stroke',
        stylers: [
            {
                lightness: '61'
            }
        ]
    }
];

const Marker = ({ cluster, supercluster, mapRef, pointsLength }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    let hideTooltipTimer = null;
    const showTooltipWindow = () => {
        setShowTooltip(true);
        if (hideTooltipTimer) {
            clearTimeout(hideTooltipTimer);
        }
    };

    const hideTooltipWindow = () => {
        hideTooltipTimer = setTimeout(() => {
            hideTooltipTimer = null;
            setShowTooltip(false);
        }, 250);
    };
    const [longitude, latitude] = cluster.geometry.coordinates;
    const { cluster: isCluster, point_count: pointCount } = cluster.properties;
    if (isCluster) {
        const markerDimensions = 10 + (pointCount / pointsLength) * 20;
        return (
            <div
                onMouseEnter={showTooltipWindow}
                onMouseLeave={hideTooltipWindow}
                className={styles.clusterMarker}
                style={{
                    width: `${markerDimensions}px`,
                    height: `${markerDimensions}px`
                }}
                onClick={() => {
                    const expansionZoom = Math.min(supercluster.getClusterExpansionZoom(cluster.id), 20);
                    mapRef.current.setZoom(expansionZoom);
                    mapRef.current.panTo({ lat: latitude, lng: longitude });
                }}>
                {pointCount}
                {showTooltip && <InfoWindow points={supercluster.getLeaves(cluster.id, 30)}></InfoWindow>}
            </div>
        );
    }

    return (
        <div onMouseEnter={showTooltipWindow} onMouseLeave={hideTooltipWindow} className={styles.marker}>
            {showTooltip && <InfoWindow points={[cluster]}></InfoWindow>}
        </div>
    );
};

const InfoWindow = ({ points }) => {
    const singlePoint = points.length === 1;

    const poinstElements = [];

    points.forEach((locationData) => {
        const locationParts = [locationData.properties.geo_device_city, locationData.properties.geo_device_country];
        const locationText = locationParts
            .filter((part) => Boolean(part))
            .map((part) => {
                return <div key={`location${part}`}>{part}</div>;
            });
        const timestampText = moment(locationData.properties.timestamp)
            .local()
            .format('L HH:mm:ss.SSS')
            .split(' ')
            .map((part) => {
                return <div key={`timestamp${part}`}>{part}</div>;
            });
        poinstElements.push(
            <div
                className={styles.locationData}
                key={`infowindow-${locationData.properties.authID}-${locationData.properties.category}`}>
                <div
                    className={styles.title}
                    title={`${locationData.properties.directoryType} ${
                        locationData.properties.host_name ? ` - ${locationData.properties.host_name}` : ''
                    }`}>
                    <img src={desktopIcon} alt="" />
                    <div className={styles.titleText}>
                        <div className={styles.directoryType}>{`${locationData.properties.directoryType}`}</div>
                        {locationData.properties.host_name && (
                            <div className={styles.hostname}>{`(${locationData.properties.host_name})`}</div>
                        )}
                    </div>
                </div>
                <div className={styles.details}>
                    <div className={styles.locationText}>
                        <i className="fa fa-map-marker" aria-hidden="true"></i>
                        <div>{locationText}</div>
                    </div>
                    <div className={styles.timestamp}>
                        <i className="fa fa-calendar" aria-hidden="true"></i>
                        <div>{timestampText}</div>
                    </div>
                </div>
            </div>
        );
    });

    function CustomArrow(props) {
        const { className, style, onClick, customStyle } = props;
        return (
            <div
                className={`pt-[1px] bg-sf-primary-500 rounded-full ${className}`}
                style={{ ...style, ...customStyle }}
                onClick={onClick}
            />
        );
    }

    const settings = {
        nextArrow: <CustomArrow customStyle={{ marginRight: '6px' }} />,
        prevArrow: (
            <CustomArrow
                customStyle={{
                    marginLeft: '6px'
                }}
            />
        )
    };

    return (
        <div
            className={`${styles.tooltipContainer} ${singlePoint ? styles.single : ''}`}
            onClick={(e) => e.stopPropagation()}>
            {singlePoint && poinstElements}
            {!singlePoint && <Slider {...settings}>{poinstElements}</Slider>}
        </div>
    );
};

const InvestigationMap = ({ points, chosenLocation }) => {
    const [bounds, setBounds] = useState(null);
    const [zoom, setZoom] = useState(10);
    const [defaultLocation, setDefaultLocation] = useState({ lat: 52.6376, lng: -1.135171 });
    const geoLocationEnabled = useFeature(FEATURE_FLAGS_NAMES.GeoLocationEnabled);
    const mapRef = useRef();

    useEffect(() => {
        if (chosenLocation.geo_device_latitude && chosenLocation.geo_device_longitude) {
            setDefaultLocation({ lat: chosenLocation.geo_device_latitude, lng: chosenLocation.geo_device_longitude });
            if (mapRef.current.panTo) {
                mapRef.current.panTo({
                    lat: chosenLocation.geo_device_latitude,
                    lng: chosenLocation.geo_device_longitude
                });
            }
        } else if (points.length) {
            setDefaultLocation({ lat: points[0].geometry.coordinates[1], lng: points[0].geometry.coordinates[0] });
        }
    }, [points, chosenLocation]);

    const { clusters, supercluster } = useSupercluster({
        points,
        bounds,
        zoom,
        options: { radius: 75, maxZoom: 20 }
    });

    if (isFeatureActive(geoLocationEnabled) && points.length > 0) {
        return (
            <div className={styles.map}>
                <GoogleMapReact
                    center={defaultLocation}
                    defaultZoom={8.2}
                    options={{ styles: MAP_STYLE }}
                    yesIWantToUseGoogleMapApiInternals
                    onGoogleApiLoaded={({ map }) => {
                        mapRef.current = map;
                    }}
                    onChange={({ zoom, bounds }) => {
                        setZoom(zoom);
                        setBounds([bounds.nw.lng, bounds.se.lat, bounds.se.lng, bounds.nw.lat]);
                    }}>
                    {clusters.map((cluster, index) => {
                        const [longitude, latitude] = cluster.geometry.coordinates;

                        return (
                            <Marker
                                lat={latitude}
                                lng={longitude}
                                key={`${index}_auth-${cluster.properties.cluster_id || cluster.properties.authID}-${
                                    cluster.properties.category
                                }`}
                                cluster={cluster}
                                supercluster={supercluster}
                                mapRef={mapRef}
                                pointsLength={points.length}></Marker>
                        );
                    })}
                </GoogleMapReact>
            </div>
        );
    } else {
        return (
            <div className={styles.banner}>
                <img src={mapPlaceholder} alt="" />
                <div className={styles.bannerText}>No location information to display</div>
            </div>
        );
    }
};

export default InvestigationMap;
